export const UPDATE_VIDEO_WATCHED_PERCENTAGE = 'UPDATE_VIDEO_WATCHED_PERCENTAGE'
export const FETCH_VIDEO_DETAILS = 'FETCH_VIDEO_DETAILS'
export const FETCH_VIDEO_DETAILS_SUCCESS = 'FETCH_VIDEO_DETAILS_SUCCESS'
export const FETCH_VIDEO_DETAILS_FAILURE = 'FETCH_VIDEO_DETAILS_FAILURE'
export const FETCH_VIDEO_DETAILS_CANCEL = 'FETCH_VIDEO_DETAILS_CANCEL'
